import type { CompanyLink, CompanySec, Products, Section } from './types'

export const products_sg: Products[] = [
  {
    tTitle: 'products.buyAndSell',
    tDesc: 'products.appDescription',
    href: '/app',
  },
  {
    tTitle: 'products.metalCards',
    tDesc: 'products.metalCardsDescription',
    href: '/cards',
  },
  {
    tTitle: 'products.pay',
    tDesc: 'products.payDescription',
    href: '/pay',
  },
  {
    tTitle: 'products.earn',
    tDesc: 'products.earnDescription',
    href: '/earn',
  },
]

export const products_desktop_sg: Section[] = [
  {
    items: [
      {
        tTitle: 'products.categoryTitle_buyAndSell',
        items: [
          {
            tTitle: 'products.app',
            tDesc: 'products.appDescription',
            href: '/sg/app',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_spend',
        items: [
          {
            tTitle: 'products.metalCards',
            tDesc: 'products.metalCardsDescription',
            href: '/sg/cards',
          },
          {
            tTitle: 'products.pay',
            tDesc: 'products.payDescription',
            href: '/sg/pay',
          },
        ],
      },
      {
        tTitle: 'products.categoryTitle_grow',
        items: [
          {
            tTitle: 'products.earn',
            tDesc: 'products.earnDescription',
            href: '/sg/earn',
          },
        ],
      },
    ],
  },
]

export const company_sg: CompanyLink[] = [
  {
    tTitle: 'company.about',
    tDesc: 'company.aboutDescription',
    href: '/sg/about',
  },
  {
    tTitle: 'company.careers',
    tDesc: 'company.careersDescription',
    href: '/sg/careers',
  },
  {
    tTitle: 'company.security',
    tDesc: 'company.securityDescription',
    href: '/sg/security',
  },
  {
    tTitle: 'company.partners',
    tDesc: 'company.partnersDescription',
    href: '/tr/partners',
  },
]

export const company_desktop_sg: CompanySec[] = [
  {
    tTitle: 'company.sectionTitle_aboutUs',
    items: [
      {
        tTitle: 'company.about',
        tDesc: 'company.aboutDescription',
        href: '/sg/about',
      },
      // {
      //   tTitle: "company.support",
      //   tDesc: "company.supportDescription",
      //   href: "https://help.crypto.com/en",
      // },
      {
        tTitle: 'company.careers',
        tDesc: 'company.careersDescription',
        href: '/sg/careers',
      },
      {
        tTitle: 'company.security',
        tDesc: 'company.securityDescription',
        href: '/sg/security',
      },
      // {
      //   tTitle: "company.news",
      //   tDesc: "company.newsDescription",
      //   href: "https://crypto.com/company-news",
      // },
      {
        tTitle: 'company.partners',
        tDesc: 'company.partnersDescription',
        href: '/sg/partners',
      },
    ],
  },
]
